import React from "react";

import LearningPathStepSection from "components/LearningPathStepSection";
import {
  Empty,
  Header,
  SectionList,
  Subtitle,
  TimelineRoot,
  Title,
} from "./styled";

export default function LearningPathTimeline({
  loadingItemId,
  onCompleteItem,
  onOpenItem,
  steps,
}) {
  const stepCount = steps?.length || 0;

  return (
    <TimelineRoot>
      <Header>
        <Title>Path steps</Title>
        <Subtitle>{stepCount} {stepCount === 1 ? "step" : "steps"}</Subtitle>
      </Header>
      {!stepCount ? (
        <Empty>No content available in this path.</Empty>
      ) : (
        <SectionList>
          {steps.map((step) => (
            <LearningPathStepSection
              key={step?.id || step?.order}
              step={step}
              loadingItemId={loadingItemId}
              onOpenItem={onOpenItem}
              onCompleteItem={onCompleteItem}
            />
          ))}
        </SectionList>
      )}
    </TimelineRoot>
  );
}
